'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.appDialogFlowSet = exports.appBotProjectIdSet = exports.appScrolledSet = exports.appChatInProgressElsewhereSet = exports.appBlockedSet = undefined;

var _types = require('../types');

var appBlockedSet = exports.appBlockedSet = function appBlockedSet(value) {
  return function (dispatch) {
    return dispatch({ payload: value, type: _types.APP_BLOCKED_SET });
  };
};

var appChatInProgressElsewhereSet = exports.appChatInProgressElsewhereSet = function appChatInProgressElsewhereSet(value) {
  return function (dispatch) {
    return dispatch({ payload: value, type: _types.APP_CHAT_IN_PROGRESS_ELSEWHERE });
  };
};

var appScrolledSet = exports.appScrolledSet = function appScrolledSet(value) {
  return function (dispatch) {
    return dispatch({ payload: value, type: _types.APP_SCROLLED_SET });
  };
};

var appBotProjectIdSet = exports.appBotProjectIdSet = function appBotProjectIdSet(id) {
  return function (dispatch) {
    return dispatch({ payload: id, type: _types.APP_BOT_PROJECT_ID_SET });
  };
};

var appDialogFlowSet = exports.appDialogFlowSet = function appDialogFlowSet(id) {
  return function (dispatch) {
    return dispatch({ payload: id, type: _types.APP_DIALOGFLOW_SET });
  };
};